<template>
  <span/>
</template>
<script>
import eventBus, { eventType } from '../utils/eventBus'

export default {
  name: 'EventBus',
  created () {
    this.bind()
  },
  activated () {
    this.bind()
  },
  destroyed () {
    this.unbind()
  },
  deactivated () {
    this.unbind()
  },
  methods: {
    bind () {
      eventBus.$on(eventType.ViewImages, this.onViewImages)
    },
    unbind () {
      eventBus.$off(eventType.ViewImages, this.onViewImages)
    },
    onViewImages (e) {
      this.$emit('onViewImages', e)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EventBus.vue